// extracted by mini-css-extract-plugin
module.exports = {"OuterDiv":"styles_OuterDiv__2zs0I","shareToLockTitle":"styles_shareToLockTitle__L1CyF","buttonsDiv":"styles_buttonsDiv__1QzhD"};